import { isDateFuture } from '../../../../utils/dateFunctions';
import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';
import {
    getNowDateOrEarlierMessage,
    getReqMessage,
    getSelectMessage, getValueRangeMessage
} from '../../../../utils/formValidation/errorMessageFunctions';

export const testValueLimits = {
    'HbA1c': { min: 31, max: 119 },
    'FPG': { min: 2, max: 13 }
};

export const NORMAL_RESULT = 'Normal';
export const PRE_DIABETES_RESULT = 'Pre-diabetes';
export const DIABETES_RESULT = 'Diabetes';
export const INVALID_RESULT = 'Invalid Value';

export const validate = (newEntry, initialRow, formType) => {
    let newErrors = {};

    if (!newEntry.eventDate) {
        newErrors = {
            ...newErrors,
            eventDate: { error: true, message: getReqMessage('Event date') }
        };
    } else if (isDateFuture(newEntry.eventDate)) {
        newErrors = {
            ...newErrors,
            eventDate: { error: true, message: getNowDateOrEarlierMessage() }
        };
    }

    if (!newEntry.eventId) {
        newErrors = {
            ...newErrors,
            eventId: { error: true, message: getSelectMessage('event', 'an') }
        };
    }

    if (!newEntry.sourceId) {
        newErrors = {
            ...newErrors,
            sourceId: { error: true, message: getSelectMessage('source') }
        };
    }

    if (!newEntry.testValue) {
        newErrors = {
            ...newErrors,
            testValue: { error: true, message: getReqMessage('A test value') }
        };
    } else {
        const limits = testValueLimits[newEntry.testType];
        if (limits && (newEntry.testValue < limits.min || newEntry.testValue > limits.max)) {
            newErrors = {
                ...newErrors,
                testValue: { error: true, message: getValueRangeMessage(limits.min, limits.max) }
            };
        }
    }

    if (formType === 'edit' && Object.keys(newErrors).length < 1) {
        newErrors = checkDiff(newEntry, initialRow);
    }

    return newErrors;
};


